import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { RoutingUtils } from 'src/app/utils';
import { BrowserDetectionService } from '../services/browser-detection/browser-detection.service';
import { SESSION_KEYS } from 'src/app/shared/constants/params.constant';
import { StorageService } from 'src/app/shared/service/storage.service';
import { SessionTimeService } from '../services/session-time/session-time.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private browserDetectionService: BrowserDetectionService,
    private storageService: StorageService,
    private sessionTimeService: SessionTimeService
  ) { }

  isLoggedIn(data: ActivatedRouteSnapshot) {
    // IMPLEMENTAR:
    const session = this.storageService.get(SESSION_KEYS.SUCCESSVALIDATION);
    const isAuthenticated = session === 'true';

    // REDIRECCIONAR SOLO PARA LOS QUE YA NO NECESITAN SESSION
    if (!isAuthenticated) {
      return this.router.navigate([RoutingUtils.AtRoot(RoutingUtils.Routes.FAILED)]);
    }
    /* Validar Browser Incompatible */
    if (this.validateBrowser()) {
      return this.router.navigate([RoutingUtils.AtRoot(RoutingUtils.Routes.INCOMPATIBLE)]);
    }
    /* Validar Tiempo de Sesión*/
    if (this.validateTimerExpired(isAuthenticated)) {
      return this.router.navigate([RoutingUtils.AtRoot(RoutingUtils.Routes.SESSION)]);
    }
    /* Validar existencia de token */
    if (this.validateHasToken()) {
      return this.router.navigate([RoutingUtils.AtRoot(RoutingUtils.Routes.FAILED)]);
    }

    return true;
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.isLoggedIn(route);
  }

  validateTimerExpired(isAuthenticated: boolean): boolean {
    return isAuthenticated && (this.sessionTimeService.calculateTimerFinish() <= 0)
  }

  validateHasToken() {
    const uuidSE = this.storageService.get(SESSION_KEYS.UUID);
    const socioSE = this.storageService.get(SESSION_KEYS.SOCIO);
    return !uuidSE || !socioSE;
  }

  validateBrowser() {
    return !this.browserDetectionService.isAnAllowedBrowser();
  }

}
